import { parseUnits } from '@ethersproject/units';
import { ERC20Token } from 'types';

export default function transferErc20(
  tokenBlacklist: string[],
  asset: ERC20Token,
  transferAction: any,
  crucibleId: string,
  amount: string,
  tokenDecimals: number,
  toCrucibleId: string | null = null
) {
  if (
    tokenBlacklist.some((token) => {
      return token.toLowerCase() === asset.address.toLowerCase();
    })
  ) {
    const confirmed = window.confirm(
      `${asset.symbol} has been flagged as a malicious token. Interacting with this token can put your wallet at risk.`
    );
    if (!confirmed) {
      return;
    }
  }

  if (toCrucibleId) {
    transferAction(
      crucibleId,
      toCrucibleId,
      asset.address || '',
      asset.symbol || '',
      tokenDecimals,
      parseUnits(amount, tokenDecimals)
    );
  } else {
    transferAction(
      crucibleId,
      asset.address || '',
      asset.symbol || '',
      tokenDecimals,
      parseUnits(amount, tokenDecimals)
    );
  }
}
